import { useId } from "react";

type Props = {
  progress: number;
  size?: number;
  strokeWidth?: number;
  baseColor?: string;
  gradientFrom?: string;
  gradientTo?: string;
};

export default function BusinessServiceCircle({
  progress,
  size = 130,
  strokeWidth = 6.5,
  baseColor = "#007FDB33",
  gradientFrom = "#007FDB",
  gradientTo = "#0164AC",
}: Props) {
  const p = Number.isFinite(progress as number) ? Number(progress) : 0;
  const clamped = Math.min(Math.max(p, 0), 100);

  const safeStroke = Number.isFinite(strokeWidth) ? strokeWidth : 0;
  const safeSize = Number.isFinite(size) ? size : 0;

  const radius = Math.max((safeSize - safeStroke) / 2, 0);
  const circumference = radius * 2 * Math.PI;
  const offset = circumference - (clamped / 100) * circumference;

  const gradientId = useId();

  return (
    <div className="relative">
      <svg className="transform -rotate-90" width={safeSize} height={safeSize}>
        <defs>
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor={gradientFrom} />
            <stop offset="100%" stopColor={gradientTo} />
          </linearGradient>
        </defs>

        <circle
          stroke={baseColor}
          strokeWidth={safeStroke}
          fill="transparent"
          r={radius}
          cx={safeSize / 2}
          cy={safeSize / 2}
        />
        <circle
          stroke={`url(#${gradientId})`}
          strokeWidth={safeStroke}
          strokeLinecap="round"
          fill="transparent"
          strokeDasharray={circumference || 0}
          strokeDashoffset={offset || 0}
          r={radius}
          cx={safeSize / 2}
          cy={safeSize / 2}
        />
      </svg>

      <span className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white text-[2rem] font-bold">
        {Math.round(clamped)}%
      </span>
    </div>
  );
}
